import { render, staticRenderFns } from "./ResourceCalendarPage.vue?vue&type=template&id=53da5461&scoped=true"
import script from "./ResourceCalendarPage.vue?vue&type=script&lang=js"
export * from "./ResourceCalendarPage.vue?vue&type=script&lang=js"
import style0 from "./ResourceCalendarPage.vue?vue&type=style&index=0&id=53da5461&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53da5461",
  null
  
)

export default component.exports